import { useCallback, useMemo } from "react";
import { useTable, useTableActions } from "../TableContext";

/**
 * Hook pour gérer les filtres de manière plus simple
 */
export const useTableFiltering = () => {
  const { state } = useTable();
  const { setFilter, removeFilter, clearFilters } = useTableActions();

  const activeFiltersCount = useMemo(() => {
    return Object.keys(state.filters).length;
  }, [state.filters]);

  const hasActiveFilters = activeFiltersCount > 0;

  const getFilterValue = useCallback((key: string) => {
    return state.filters[key];
  }, [state.filters]);

  const isFilterActive = useCallback((key: string) => {
    return key in state.filters;
  }, [state.filters]);

  return {
    filters: state.filters,
    filtersReferential: state.filtersReferential,
    loadingFilters: state.loadingFilters,
    activeFiltersCount,
    hasActiveFilters,
    setFilter,
    removeFilter,
    clearFilters,
    getFilterValue,
    isFilterActive
  };
};
